export interface CalendarDTO {
    id: number;
    userId: number;
    calendarIntegrationId: number;
    calendarIntegrationName: string;
    externalCalendarId: string;
    summary: string;
    showInDashboard: boolean;
    showInNotes: boolean;
    uuid: string;
    taskUuid: string;
    color: string;
    url: string;
}

export interface CalendarWriteDTO {
    userId: number;
    calendarIntegrationId: number;
    externalCalendarId: string;
    summary: string;
    showInDashboard: boolean;
    showInNotes: boolean;
    uuid: string;
    taskUuid: string;
    color: string;
    url: string;
}

export function createCalendar(    userId: number,
    calendarIntegrationId: number,
    externalCalendarId: string,
    summary: string,
    showInDashboard: boolean,
    showInNotes: boolean,
    uuid: string,
    taskUuid: string,
    color: string,
    url: string
) {
    return {userId: userId, calendarIntegrationId: calendarIntegrationId, externalCalendarId: externalCalendarId,
        summary: summary, showInDashboard: showInDashboard, showInNotes: showInNotes, uuid: uuid, taskUuid: taskUuid, color: color, url: url}
}